import type { FC } from 'react';

interface Props {
  description: string | undefined;
}

const PropertyDescriptionCard: FC<Props> = ({ description }) => {
  if (!description) {
    return null;
  }

  return (
    <div className="bg-white p-8 rounded-none border border-gray-200">
      <h2 className="text-2xl font-bold text-gray-900 mb-4">About This Floor Plan</h2>
      <p className="text-gray-700 leading-relaxed">{description}</p>
    </div>
  );
};

export default PropertyDescriptionCard;
